import React from 'react'


const noRegistrado = () => {
    return(
        <section>
            <div className="suscripto">
        <h1>USUARIO NO REGISTRADO</h1>
        <p>
            vuelve a intentarlo con los datos correctos !
        </p>
        </div>
        </section>
    )
}
export default noRegistrado